import { Fragment, type PropsWithChildren, memo, useState } from 'react';
import type { ITransaction } from '@recargas-dominicanas/core/types';
import { TransactionApi } from '@recargas-dominicanas/core/api';
import { LoadingModal, TransactionItem } from '@recargas-dominicanas/core/components';
import { useBusiness, useSales, useSalesReport, useTransactions } from '@recargas-dominicanas/core/store';
import { ErrorModal } from '../error-modal/error-modal.component';
import { InsuranceModal } from '../insurance-modal/insurance-modal.component';
import { printInsurance } from '../../utils/printInsurance';
import { InsuranceCancelModal } from '../insurance-cancel-modal/insurance-cancel-modal.component';

interface Props {
  transaction: ITransaction;
}

export const InsuranceItem = memo(function InvoiceItem(props: Props) {

  const { transaction } = props;

  const businessStore = useBusiness();
  const salesReport = useSalesReport();
  const transactions = useTransactions();
  const salesStore = useSales();
  const business = businessStore.get();
  const [openInsuranceModal, setOpenInsuranceModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openLoadingModal, setOpenLoadingModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessfulModal, setOpenSuccessfulModal] = useState(false);

  function handleOpenCancelModal() {
    setOpenInsuranceModal(false);
    setOpenCancelModal(true);
  }

  async function handleCancel() {

    setOpenCancelModal(false);
    setOpenLoadingModal(true);

    try {

      await TransactionApi.cancelInsurance(transaction.product.id, transaction.id);
      
      await Promise.allSettled([
        salesStore.fetch(),
        salesReport.fetchCurrent(),
        transactions.fetchGroupByDay(1, 50)
      ]);

      setOpenLoadingModal(false);
      setOpenSuccessfulModal(true);
    
    } catch {

      setOpenLoadingModal(false);
      setOpenErrorModal(true);
    }
  }

  return (
    <Fragment>
      <TransactionItem
        key={transaction.id}
        transaction={transaction}
        showMenu={false}
        onClick={() => setOpenInsuranceModal(true)}
        onCancel={() => setOpenCancelModal(true)}/>
      <InsuranceModal
        open={openInsuranceModal}
        title='Seguro'
        transaction={transaction}
        onPrint={() => printInsurance(business, transaction)}
        onCancel={handleOpenCancelModal}
        onClose={() => setOpenInsuranceModal(false)}/>
      <InsuranceCancelModal
        open={openCancelModal}
        transaction={transaction}
        overlayEnterAnimation={false}
        onAccept={handleCancel}
        onClose={() => setOpenCancelModal(false)}/>
      <LoadingModal
        open={openLoadingModal}
        title='Cancelando seguro'
        overlayEnterAnimation={false}/>
      <InsuranceModal
        open={openSuccessfulModal}
        title='Seguro cancelado'
        transaction={transaction}
        overlayEnterAnimation={false}
        onPrint={() => printInsurance(business, transaction!)}
        onClose={() => setOpenSuccessfulModal(false)}/>
      <ErrorModal
        open={openErrorModal}
        overlayEnterAnimation={false}
        title='Error cancelando seguro'
        description='Ocurrio un error al cancelar el seguro.'
        onClose={() => setOpenErrorModal(false)}/>
    </Fragment>
  );
}, propsAreEqual);

function propsAreEqual(prev: PropsWithChildren<Props>, next: PropsWithChildren<Props>) {
  return (
    prev.transaction.id === next.transaction.id &&
    prev.transaction.cancelled === next.transaction.cancelled
  );
}
